import React from 'react';
import * as models from 'src/models';
import * as localization from 'src/localization';
import { GetProps } from 'src/types/Utility';
import useLocalized from 'src/hooks/useLocalized';
import Row from 'src/components/Row';
import Text from 'src/components/Text';
import ListGroup from 'src/components/ListGroup';

export type Props = Omit<GetProps<typeof ListGroup>, 'children'> & {
  institution: models.institution.types.Institution;
};

const InstitutionDetails: React.FC<Props> = ({ institution, ...rest }) => {
  const localized = useLocalized((env) => ({
    component: localization.components.InstitutionDetails.localized(env),
    institution: localization.models.institution.create(institution)(env)
  }));

  return (
    <ListGroup {...rest}>
      <ListGroup.Item>
        <Row>
          <Row.Column size={1}>
            <Text variant="subhead">{localized.component.name}</Text>
          </Row.Column>
          <Row.Column size={4}>
            <Text variant="body">{localized.institution.name}</Text>
          </Row.Column>
        </Row>
      </ListGroup.Item>
      <ListGroup.Item>
        <Row>
          <Row.Column size={1}>
            <Text variant="subhead">{localized.component.type}</Text>
          </Row.Column>
          <Row.Column size={4}>
            <Text variant="body">{localized.institution.type}</Text>
          </Row.Column>
        </Row>
      </ListGroup.Item>
      <ListGroup.Item>
        <Row>
          <Row.Column size={1}>
            <Text variant="subhead">{localized.component.status}</Text>
          </Row.Column>
          <Row.Column size={4}>
            <Text variant="body">{localized.institution.status}</Text>
          </Row.Column>
        </Row>
      </ListGroup.Item>
    </ListGroup>
  );
};

export default InstitutionDetails;
